// 格式化函数
export const formatNum = (val, divisor = 1, fixed) => {
  // 数值，除数，小数位数
  if (val === null || val === undefined || val === "") return "--";
  return (Number(val) / divisor).toFixed(fixed);
};

/**
 * 为空
 * @param val
 * @returns {boolean}
 */
export const isEmpty = (val) => {
  if (val === null || typeof val === "undefined" || (typeof val === "string" && val === "" && val !== "undefined")) {
    return true;
  }
  return false;
};

/**
 * 强转int型
 * @param val
 * @param defaultValue
 * @returns {number}
 */
export const toInt = (val, defaultValue) => {
  if (isEmpty(val)) {
    return defaultValue === undefined ? -1 : defaultValue;
  }
  const num = parseInt(val, 0);
  return Number.isNaN(num) ? (defaultValue === undefined ? -1 : defaultValue) : num;
};
